import { getCurrentInstance } from 'vue';

export function useOfflineCompat() {
  const { proxy } = getCurrentInstance();
  if (!proxy) throw new Error('useOfflineCompat debe usarse dentro de setup()');

  return proxy.$offline;
}
